export const WEB_SDK_SOURCE = 'YandexTrustWebSDK';

export const PAN_SIZE = 16;
